import { Button } from '@mui/material';
import BaseTable from 'components/ui/tables/BaseTable';
import useTopPanel from 'hooks/useTopPanel';
import React, { memo, useEffect, useState } from 'react';
import AddEditModal from './WarehouseAddEditModal';
import SimpleSearchInput from 'components/SearchInputNavbar';
import { useNavigate } from 'react-router-dom';
import useMenu from 'hooks/useMenu';
import WarehouseImportModal from './WarehouseImportModal';
import WarehouseFilterDrawer from '../../../components/dashboard/WarehouseFilterDrawer';

const Warehouse = () => {
  const { setComponent } = useTopPanel();
  const navigate = useNavigate();
  const { hasChild } = useMenu();
  const view = (child) => {
    return !hasChild('SETTINGS', child);
  };

  useEffect(() => {
    setComponent(<div className='component-title'>Omborlar</div>);
    localStorage.removeItem('warehouse-item-data');
  }, []);

  const [refetch, setRefetch] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [itemData, setItemData] = useState('');
  // ✅ Import bilan bog'liq state'lar
  const [openImportModal, setOpenImportModal] = useState(false);
  const [importItemData, setImportItemData] = useState('');

  const onInbound = (data) => {
    navigate(`${data?.id}/inbound`);
  };
  const onOutbound = (data) => {
    navigate(`${data?.id}/outbound`);
  };
  const onChecklist = (data) => {
    navigate(`${data?.id}/checklist`);
  };
  const onHistory = (data) => {
    navigate(`${data?.id}/history`);
  };
  const onOutcome = (data) => {
    navigate(`${data?.id}/outcome`);
  };
  const onReturn = (data) => {
    navigate(`${data?.id}/return-list`);
    localStorage.setItem('warehouse-item-data', JSON.stringify(data));
  };

  const actionsList = [
    {
      icon: 'bi bi-bootstrap-reboot',
      btnColor: 'error',
      code: 'ORDER_RETURN',
      setOpen: () => {},
      setData: onReturn,
    },
    {
      icon: 'bi bi-box-arrow-in-down',
      btnColor: 'success',
      setOpen: () => {},
      setData: onInbound,
    },
    {
      icon: 'bi bi-box-arrow-up',
      btnColor: 'error',
      setOpen: () => {},
      setData: onOutbound,
    },
    {
      icon: 'bi bi-eye',
      btnColor: 'info',
      setOpen: () => {},
      setData: onChecklist,
    },
    {
      icon: 'bi bi-list-check',
      btnColor: 'primary',
      setOpen: () => {},
      setData: onHistory,
    },
    {
      icon: 'bi bi-file-earmark-arrow-down',
      btnColor: 'success',
      code: 'WAREHOUSE_UPLOAD',
      setOpen: setOpenImportModal,
      setData: setImportItemData,
    },
    {
      // icon: 'bi bi-check-circle',
      icon: 'bi bi-dash-circle',
      btnColor: 'primary',
      code: 'WAREHOUSE_UPLOAD',
      setOpen: () => {},
      setData: onOutcome,
    },
    {
      icon: 'bi bi-pencil-square',
      btnColor: 'info',
      setOpen: setOpenModal,
      setData: setItemData,
    },
  ].filter((a) => true || view(a.code));

  return (
    <div className='component-list-wrapper'>
      <div className='component-list-header mb-2'>
        <div className='header-actions-container py-3 flex flex-row items-center'>
          <div className='header-actions filter-box flex items-center px-4 w-full'>
            <Button
              variant='base'
              color='primary'
              startIcon={<i className='bi bi-filter' />}
              className='!mr-2'
              onClick={() => setOpenFilter(true)}
            >
              Filter
            </Button>
            <SimpleSearchInput inputKey='name' />
          </div>
          <div className='header-actions action-buttons-box py-3 px-4 flex items-center justify-center'>
            <Button
              variant='base'
              color='info'
              onClick={() => {
                setRefetch(true);
              }}
              disable={`${refetch}`}
            >
              <i
                className={`bi bi-arrow-repeat${
                  refetch ? ' animate-spin' : ''
                }`}
              />
            </Button>
            <Button
              variant='base'
              color='success'
              className='!mx-2'
              onClick={() => setOpenModal(true)}
            >
              <i className='bi bi-plus-circle' />
            </Button>
            <Button
              variant='base'
              color='default'
              onClick={() => setOpen(true)}
            >
              <i className='bi bi-gear' />
            </Button>
          </div>
        </div>
      </div>

      <div className='component-table-wrapper h-[calc(100vh-180px)]'>
        <BaseTable
          emitRefetch={{ refetch, setRefetch }}
          dataPath='admin/warehouses/index'
          emitTableColumns={{ open, setOpen }}
          tableName='warehouses'
          headCells={[
            { code: 'name', label: 'Nomi' },
            { code: 'user', label: "Mas'ul xodim" },
            { code: 'status', label: 'Status' },
          ]}
          columns={[
            { code: 'name' },
            {
              code: 'user',
              type: 'nested',
              childStr: 'name',
            },
            {
              code: 'status',
              type: 'status',
              label: { true: 'aktiv', false: 'aktiv emas' },
            },
          ]}
          actionsList={actionsList}
        />
      </div>
      {openModal && (
        <AddEditModal
          open={openModal}
          setOpen={setOpenModal}
          itemData={itemData}
          setItemData={setItemData}
          setRefetch={setRefetch}
        />
      )}
      {openImportModal && (
        <WarehouseImportModal
          open={openImportModal}
          setOpen={setOpenImportModal}
          itemData={importItemData}
          setRefetch={setRefetch}
          itemId={importItemData?.id} // ✅ mana bu muhim
          setItemId={setImportItemData} // <-- qo'shing bu qatorni
        />
      )}
      {<WarehouseFilterDrawer open={openFilter} setOpen={setOpenFilter} />}
    </div>
  );
};

export default memo(Warehouse);
